export class CriticalColumnSlo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "nullRateSlo",
            "baseName": "nullRateSlo",
            "type": "number",
            "format": "double"
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "ColumnRole",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CriticalColumnSlo.attributeTypeMap;
    }
    constructor() {
    }
}
